import React from "react";

export default function VehicleInfoModal() {
    return (
        <div
            className="modal fade"
            id="vehicleInfoModal"
            tabIndex="-1"
            aria-labelledby="vehicleInfoModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">

                    {/* Header */}
                    <div className="modal-header">
                        <h5 className="modal-title" id="vehicleInfoModalLabel">
                            🚖 Vehicle Details
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                        ></button>
                    </div>

                    {/* Body */}
                    <div
                        className="modal-body"
                        style={{ maxHeight: "60vh", overflowY: "auto" }}
                    >
                        <div className="row g-3">

                            {/* Card */}
                            {[
                                {
                                    title: "🚗 Hatchback",
                                    details: [
                                        "👥 Up to 4 passengers",
                                        "🧳 1–2 small bags",
                                        "WagonR, Swift or similar",
                                        "✔ Budget-friendly",
                                        "✔ Best for short rides"
                                    ]
                                },
                                {
                                    title: "🚘 Sedan",
                                    details: [
                                        "👥 Up to 4 passengers",
                                        "🧳 2–3 medium bags",
                                        "Dzire, Aura or similar",
                                        "✔ Comfortable rides",
                                        "✔ Ideal for airport travel"
                                    ]
                                },
                                {
                                    title: "🚐 Mid MPV",
                                    details: [
                                        "👥 Up to 6 passengers",
                                        "🧳 3–4 bags",
                                        "Ertiga, Carens or similar",
                                        "✔ Great for families",
                                        "✔ Extra space & comfort"
                                    ]
                                },
                                {
                                    title: "🚐 Big MPV",
                                    details: [
                                        "👥 Up to 6 passengers",
                                        "🧳 4–6 bags",
                                        "Innova or similar",
                                        "✔  Perfect for group travel",
                                        "✔ Best for long & outstation rides"
                                    ]
                                }
                            ].map((vehicle, index) => (
                                <div className="col-12 col-md-6" key={index}>
                                    <div className="border rounded p-3 h-100">
                                        <h6 className="fw-bold mb-2">
                                            {vehicle.title}
                                        </h6>
                                        <ul className="mb-0 small">
                                            {vehicle.details.map((item, i) => (
                                                <li key={i}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            ))}

                        </div>

                        {/* Note */}
                        <div className="mt-3 small text-muted">
                            <strong>🔻 Note:</strong> Vehicle model may vary based on availability, but category, seating, and luggage capacity will remain consistent.
                        </div>
                    </div>
                    <div className="modal-footer moreInfo_modal-footer">
                        <button type="button" className="btn" data-bs-dismiss="modal"> Got it !</button>
                    </div>
                </div>
            </div>
        </div>
    );
}